type languageType = "en" | "fr"
export let languages: languageType[] = ["en", "fr"];
export let languageNames: { [key in languageType]: String } = {
    en: "English",
    fr: "Français",
};
export let defaultLanguage: languageType = "fr"
export const texts: { [key: string]: { [lang in languageType]: string } } = {
    title: {
        en: "No perfect soup",
        fr: "La soupe parfaite n'existe pas !"
    },
    subtitle: {
        en: "(A sweet introduction to nonnegative matrix factorization)",
        fr: "(Une introduction en douceur à la factorisation en matrices non-négatives)"
    },
    credits_J: {
        en: "Jérémy Cohen: story, research",
        fr: "Jérémy Cohen : rédaction, recherche"

    },
    credits_LF: {
        en: "Lucas Franceschino: developpement",
        fr: "Lucas Franceschino : développement"

    },
    credits_A: {
        en: "Anaïs Rallo: illustrations",
        fr: "Anaïs Rallo : illustrations"

    },
    credits_LG: {
        en: "Lucie Goujon: web developpement",
        fr: "Lucie Goujon : développement web"

    },
    first_1: {
        en: "A new soup shop in Teddy land",
        fr: "Un nouveau restaurant de soupes au pays des nounours"
    },
    first_2: {
        en: "Everyone knows how hard it can be to please everyone. Well, that's mostly because finding out what makes other people happy is more than often very difficult, even for close friends of family.",
        fr: "Nous savons tous qu'il peut être difficile de satisfaire tout le monde. N'est-il pas déjà très difficile de savoir ce qui fait plaisir aux autres, y compris ses amis proches et sa famille ?"
    },
    first_3: {
        en: "Let's take a small trip to the fantastic world of teddy bears!",
        fr: "Plongeons-nous dans le monde fantastique des nounours."
    },
    first_4: {
        en: "In their world, there exist a small soup shop that wants to serve the best soup for every single teddy bear out there. After all, what's more comforting than a warm soup during cold winter nights?",
        fr: "Au pays des nounours, il existe un petit restaurant tout neuf qui aspire à servir la meilleure des soupes pour chacun de ses clients. Après-tout, qu'y a-t'il de plus réconfortant qu'une bonne soupe chaude les rudes soirées d'hiver ?"
    },
    second_1: {
        en: "For now, the chef is focusing on three ingredients for his delicious soup:",
        fr: "Le chef de ce restaurant se concentre sur trois ingrédients pour préparer ses délicieuses soupes :"
    },
    second_2: {
        en: "leaks,",
        fr: "des poireaux,"
    },
    second_3: {
        en: "onions",
        fr: "des oignons"
    },
    second_4: {
        en: "and carrots",
        fr: "et des des carottes"
    },
    third_1: {
        en: "Let's help the chef make his first soup!",
        fr: "Aidons le chef à faire sa première soupe !"
    },
    third_2: {
        en: "For this first recipe, the chef wants a soup that contains at least 60% carrots and less than 10% oignons.",
        fr: "Pour cette première recette, le chef veut une soupe qui contient au moins 60% de carottes et moins de 10% d'oignons."
    },
    third_3: {
        en: "Move the soup in the plot so that the chef cooks a tasty soup!",
        fr: "Bouge la soupe sur le graphique pour que le chef prépare une bonne soupe !"
    },
    carrot: {
        en: "carrot",
        fr: "carotte"
    },
    leak: {
        en: "leak",
        fr: "poireau"
    },
    onion: {
        en: "onion",
        fr: "oignon"
    },
    fourth_1: {
        en: "The chef has the perfect super teddy-power for this task: he can guess in advance the tastes of his customers.",
        fr: "Pour l'aider dans sa tâche, le chef dispose d'un super pouvoir de nounours : il peut deviner à l'avance les goûts de ses clients. Quelle chance !"
    },
    fourth_2: {
        en: "For now, he has only one client, Gaston! Because of its super-guessing powers, the chef knows perfectly Gaston's tastes for soup.",
        fr: "Pour l'instant, il n'a qu'un seul client, Gaston. Grace à son super pouvoir, le chef connait parfaitement les goûts de Gaston."
    },
    fourth_3: {
        en: "Gaston likes oignons quite a lot, and carrots a little bit. He does not like leaks.",
        fr: "Gaston aime beaucoup les oignons et un peu les carottes. Il n'aime pas du tout les poireaux."
    },
    fourth_4: {
        en: "And his perfect soup would contain 30% of carrots, 70% of oignons and 0% of leaks.",
        fr: "Sa soupe parfaite contiendrait 30% de carottes, 70% d'oignons et 0% de poireaux."
    },
    fourth_5: {
        en: "Therefore, for our good-soup shop, satisfying Gaston is a piece of cake!",
        fr: "Pour notre chef, servir la soupe parfaite de Gaston est facile comme bonjour !"
    },
    fourth_6: {
        en: "Let's see if you can design the perfect soup to serve Gaston!",
        fr: "Voyons si nous pouvons nous aussi fabriquer cette soupe !"
    },
    fourth_7: {
        en: "Toy with Gaston's tastes on the graph below!",
        fr: "Joue avec les goûts de Gaston sur le graphique ci-dessous !"
    },
    fifth_1: {
        en: "Success and challenges",
        fr: "Des succès et des échecs"
    },
    fifth_2: {
        en: "Foxxy, the cute red fox and a good friend of Gaston, and two bunnies have heard of the quality of the soup and want to become clients as well! Good job soup shop.",
        fr: "Foxxy le renard roux, qui est un bon ami de Gaston, et deux autres nounours lapins ont entendu parler de la qualité des soupes de notre restaurant et veulent également devenir clients. Bien joué Chef !"
    },
    fifth_3: {
        en: "However, that's going to make satisfying everyone a little harder.",
        fr: "Cependant, cela ne risque t-il pas de rendre la satisfaction de chacun plus difficile ? Observons ce qu'il va bien pouvoir se passer."
    },
    fifth_4: {
        en: "After activating its super-guessing powers, the chef has sensed the following tastes for its new clients.",
        fr: "Après avoir utilisé son super-pouvoir, le chef a obtenu les goûts de chacun de ses nouveaux clients. Aidons-le à préparer la soupe !"
    },
    fifth_5: {
        en: "The chef is in a pinch.",
        fr: "Le chef est dans le pétrin."
    },
    fifth_6: {
        en: "If he prepares a single soup, he cannot satisfy all the teddys, even when trying his best.",
        fr: "S'il ne prépare qu'une seule soupe, malgré notre aide et toute la bonne volonté du monde, il ne peut pas satisfaire tous ses clients."
    },
    fifth_7: {
        en: "That's not the kind of chef he was meant to be!",
        fr: "Ce n'est pas le genre de chef qu'il voulait devenir !"
    },
    sixth_1: {
        en: "More soups?",
        fr: "Il nous faut plus de soupes"
    },
    sixth_2: {
        en: "Well, the chef gets a first idea: if one soup does not satisfy everyone, then he will simply make more soups, and pick the best one for each customer.",
        fr: "Le chef a une première idée: si une seule soupe ne suffit pas à satisfaire tout le monde, alors il fera plus de soupes différentes, et choisira la meilleure pour chacun de ses clients."
    },
    sixth_3: {
        en: "But making soup is very time consuming, and our chef can only work so much.",
        fr: "Mais faire une soupe au pays des nounours est très fatigant."
    },
    sixth_4: {
        en: "After hours of intensive cooking he barely manages to produce two soups. Now things are surely improved because the teddies can pick their preferred soup!",
        fr: "Notre chef ne pouvant pas travailler plus que raison, il se résout après des heures intensives en cuisine à ne proposer que deux soupes au total. Les choses devraient maintenant s'arranger, car les nounours peuvent choisir leur soupe préférée !"
    },
    sixth_5: {
        en: "But did this make the teddies happy?",
        fr: "Mais cela va-t-il suffir à satisfaire tous ces clients affamés ?"
    },
    sixth_6: {
        en: "Well let's check it out depending on the chosen soups!",
        fr: "Vérifions-le en aidant le chef dans sa préparation."
    },
    seventh_1: {
        en: "It depends on their tastes, but in general, no, there are still unhappy Teddies.",
        fr: "Cela dépend forcément du goût des clients, mais dans notre cas les nounours sont ne sont jamais tous satisfaits."
    },
    seventh_2: {
        en: "The chef is depressed, and the customers are unhappy.",
        fr: "Le chef est triste et ses clients mécontents."
    },
    seventh_3: {
        en: "Things could not be worse.",
        fr: "La situation ne pourrait être pire."
    },
    eighth_1: {
        en: "No perfect soup: The ambitious personnalisation plan",
        fr: "La soupe parfaite n'existe pas ! Un ambitieux plan de personnalisation"
    },
    eighth_2: {
        en: "One day Gaston, still a faithful client of the soup shop, comes up with an interesting idea:",
        fr: "Un jour Gaston, toujours un client fidèle du restaurant, a une idée intéressante :"
    },
    eighth_3: {
        en: "instead of making two different soups and serving the customers with only one,",
        fr: "plutôt que de faire deux soupes et d'en servir une seule à chaque client,"
    },
    eighth_4: {
        en: "why not serve each client with a mixture of both?",
        fr: "pourquoi ne pas servir un mélange des deux, personnalisé pour chaque client ?"
    },
    ninth_1: {
        en: "The chef thinks about it.",
        fr: "Le chef y réfléchit."
    },
    ninth_2: {
        en: "He does not really know if this will help, but he might as well try!",
        fr: "Il ne sait pas vraiment si mélanger les soupes va pouvoir l'aider, mais il se dit qu'il n'a rien à y perdre."
    },
    ninth_3: {
        en: "Because he knows the preferences of each customer, maybe he would be able to mix the two soups optimally for each customer, right?",
        fr: "Après tout, s'il connait les goûts de tous ses clients, il devrait être capable de servir le mélange optimal à chacun !"
    },
    ninth_4: {
        en: "He first tries this out on Gaston.",
        fr: "Il fait une première expérience sur Gaston."
    },
    ninth_5: {
        en: "Making two soups that are not up to Gaston standards, could he mix them and make his client and friend happy?",
        fr: "Peut-on aider le chef à faire deux soupes dont le mélange satisfasse son client et ami, même si chacune de ces soupes n'est pas à son goût ?"
    },
    tenth_1: {
        en: "Despite each individual soup the chef prepared not being Gaston's tastes, by serving them to Gaston in a specific proportion, he could make him happy. The line that connects the two soups contains all the possible outcomes of mixing these soups. And the chef serves Gaston the best possible combination!",
        fr: "Et oui ! Même si chacune des soupes ne plait pas forcément à Gaston, en les servant en bonne proportion, le chef peut satisfaire Gaston. Le trait qui relie les deux soupes représente en effet toutes les soupes que l'on peut obtenir en mélangeant les deux soupes de base ; et le chef sert à Gaston la meilleure combinaison !"
    },
    tenth_2: {
        en: "The chef could not believe his eyes.",
        fr: "Le chef n'en croit pas ses yeux."
    },
    tenth_3: {
        en: "He hires a super-fast-computing assistant to help him with the proportions for the mixings, and invites all the teddies for a meal.",
        fr: "Il embauche un assistant très fort en calcul mental pour l'aider à calculer les proportions pour les mélanges et invite tous les nounours pour un repas dans son restaurant."
    },
    tenth_4: {
        en: "Will he be able to design the two perfect base soups to satisfy everyone?",
        fr: "Pouvons-nous l'aider à concevoir deux soupes pour satisfaire tous ses clients ?"
    },
    eleventh_1: {
        en: "Take away message",
        fr: "Ce qu'il faut retenir"
    },
    eleventh_2: {
        en: "Now back to real life.",
        fr: "Revenons au monde réel."
    },
    eleventh_3: {
        en: "We are not able, like the soup chef, to guess people's tastes. And even if we could, making gifts or choices that satisfy everyone can be incredibly hard.",
        fr: "Nous ne sommes pas capables, comme le chef, de deviner le goût des autres. Et même si nous le pouvions, faire des choix qui font plaisir à tous peut s'avérer impossible, même dans un cadre simple comme celui d'un restaurant de soupes."
    },
    eleventh_4: {
        en: "If choices are not 3 dimensional, but involve an almost infinite number of parameters. Even with nowadays mathematics, we don't know how to solve this problem very efficiently!",
        fr: "En fait, même avec la puissance des mathématiques modernes, nous sommes incapables de résoudre le dernier puzzle de façon efficace !"
    },
    eleventh_5: {
        en: "Thanks for reaching the end ! Before leaving, have fun creating impossible setups on the plot below! (you can now move the teddies)",
        fr: "Merci d'avoir tout lu ! Avant de partir, amusez-vous à créer des situations impossibles même en mélangeant deux soupes (vous pouvez maintenant bouger les nounours !)"
    },
    footer_1_1: {
        en: "The first problem illustrated here (two soups and no mixing) is called data clustering. In particular it is here an instance of the ",
        fr: "Le premier problème illustré ici (deux soupes, pas de mélanges) est le partitionnement des données, en particulier "    
    },
    footer_1_2_url: {
        en: "https://en.wikipedia.org/wiki/K-means_clustering",
        fr: "https://fr.wikipedia.org/wiki/K-moyennes"
    },
    footer_1_2: {
      en: "k-means clustering ",
      fr: "le problème des k-moyennes ", 
    },
    footer_1_3: {
        en: "problem: the goal is to summarize the tastes of the teddies in two homogeneous groups. Up to this day, scientists are still unsure how to solve it both very fast and optimally, especially when the number of teddies increases significantly. K-means clustering is one of the main ",
        fr: "(k-means clustering en anglais). On veut résumer les goûts des nounours en deux groupes homogènes. Encore de nos jours, on ne sait pas résoudre de façon rapide et optimale le problème des k-moyennes, surtout lorsque le nombre de nounours augmente beaucoup ! C'est un des problèmes centraux de ",      
    },
    footer_1_4_url: {
        en: "https://en.wikipedia.org/wiki/Unsupervised_learning",
        fr: "https://fr.wikipedia.org/wiki/Apprentissage_non_supervis%C3%A9"  
    },
    footer_1_4: {
        en: "unsupservised machine learning",
        fr: "l'analyse de données non-supervisée"  
    },
    footer_1_5: {
        en: " problem",
        fr: ", qui constitue une partie importante de la science des données."  
    },
    footer_2_1: {
        en: "The second problem in which the chef satisfies all his clients is an example of ",
        fr: "Le deuxième problème qui permet au chef de satisfaire tous ses clients est une illustration de la "  
    },
    footer_2_2_url: {
        en: "https://en.wikipedia.org/wiki/Non-negative_matrix_factorization",
        fr: "https://en.wikipedia.org/wiki/Non-negative_matrix_factorization"    
    },
    footer_2_2: {
        en: "Nonnegative Matrix Factorization. ",
        fr: "Factorisation en Matrices Nonnégatives "    
    },
    footer_2_3: {
        en: "Once again this is an unsupervsied machine learning problem used intensively in various applications such as ",
        fr: "(souvent notée NMF qui est son acronyme en anglais). Là encore il s'agit d'un problème d'apprentissage non-supervisé très utilisé pour des applications aussi diverses que la "    
    },
    footer_2_4_url: {
        en: "https://www.eecs.qmul.ac.uk/~simond/pub/2018/BenetosDixonDuanEwert-SPM2018-Transcription.pdf",
        fr: "https://www.eecs.qmul.ac.uk/~simond/pub/2018/BenetosDixonDuanEwert-SPM2018-Transcription.pdf"    
    },
    footer_2_4: {
        en: "Music Automatic Transcription",
        fr: "transcription de musique automatique"    
    },
    footer_2_5: {
        en: " in which one tries to recover a music sheet from an audio recording, or the analysis of",
        fr: " (retrouver la partition à partir d'un enregistrement audio) ou de "    
    },
    footer_2_6_url: {
        en: "https://oatao.univ-toulouse.fr/19120/1/thouvenin_19120.pdf",
        fr: "https://oatao.univ-toulouse.fr/19120/1/thouvenin_19120.pdf"    
    },
    footer_2_6: {
        en: " remotely acquired hyperspectral images.",
        fr: "l'analyse d'image satelites."    
    },
    footer_2_7: {
        en: " Similarly to the K-means problem, but actually even more so, presently scientists do not have fast algorithms that solve the Nonnegative Matrix Factorization problem optimally when the number of soups and clients is large!",
        fr: " Comme pour les k-moyennes, à l'heure actuelle on ne sait pas résoudre optimalement le problème NMF notamment lorsque le nombre de soupes et de clients est élevé !"    
    },
    footer_credits: {
        en: "This mediation project is funded by the French National Research Agency (ANR) through the ANR project JCJC LoRAiA. This project, in a nutshell, deals with the choice of the best soups when a catalogue of such soups is available and fixed!",
        fr: "Ce projet de vulgarisation est financé par l'Agence Nationale de la Recherche à travers le projet ANR JCJC LoRAiA, qui, pour simplifier, porte sur le choix des meilleures soupes pour la NMF parmis un catalogue de recettes fixées !",      
    }
};

